import { render } from "./radio-input.vue?vue&type=template&id=55c08216"
import script from "./radio-input.vue?vue&type=script&lang=js"
export * from "./radio-input.vue?vue&type=script&lang=js"

import "./radio-input.vue?vue&type=style&index=0&id=55c08216&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__